import { Spin } from 'antd'
import styled from 'styled-components'

const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`

const LoadingComponent = () => {
  return (
    <LoadingWrapper>
      <Spin size="large" role="status" />
    </LoadingWrapper>
  )
}

export default LoadingComponent
